module.exports = __webpack_public_path__ + "img/zaantje.4ae5b97a.svg";